<template>
  <ur-modal ref="modal" title="나의 정보">
    <div>
      <div class="box_border">
        <h2>기본 정보</h2>
        <div class="tbl_view type2">
          <table>
            <colgroup>
              <col style="width: 194px" />
              <col style="width: auto" />
            </colgroup>
            <tbody>
              <tr>
                <th>이름</th>
                <td>{{ userName }}</td>
              </tr>
              <tr>
                <th>레벨</th>
                <td>{{ level }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box_border">
        <h2>연락처 정보</h2>
        <div class="tbl_view type2">
          <table>
            <colgroup>
              <col style="width: 194px" />
              <col style="width: auto" />
            </colgroup>
            <tbody>
              <tr>
                <th>이메일</th>
                <td>{{ email }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box_border">
        <h2>계정 삭제</h2>
        <table>
          <tbody>
            <tr>
              <td style="text-align: center">
                계정 삭제 시 모든 AICC 솔루션 서비스를 사용하실 수 없습니다.
                <a @click="onClickManagerCheck" class="delete_link">　삭제 신청</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template slot="action">
      <ur-button @click="close" main>확인</ur-button>
    </template>
    <delete-user-modal ref="deleteUserModal"  />
  </ur-modal>
</template>
<script>
import { addTouchMoveListener } from "vue-json-editor/assets/jsoneditor";
import AuthManager from "~system/auth/AuthManager";
import deleteUserModal from './deleteUserModal';

export default {
  components:{
    deleteUserModal
  },
  data() {
    return {
      password: "",
      userDeleteAsk: {
        password: "",
      },
      withdrawStatus: {
        show: false,
      },
    };
  },
  computed: {
    userName() {
      return this.$store.getters.userInfo.userName;
    },
    userId() {
      return this.$store.getters.userInfo.userId;
    },
    level() {
      return this.$store.getters.userInfo.userGroupName;
    },
    email() {
      return this.$store.getters.userInfo.email;
    },
    cellphone() {
      return this.$store.getters.userInfo.cellphone;
    },
  },
  methods: {
    open() {
      this.$refs["modal"].open();
    },
    close() {
      this.$refs["modal"].close();
    },
    onClickManagerCheck() {
      this.password = "";
      http
        .request(this.contextPageId, "DTS_CMP_00141", {
          path: {
            userid: this.userId,
          },
        })
        .then((response) => {
          if (response.data.reply.code === "0000") {
            this.$refs.deleteUserModal.open();
          } else {
            utils.aiccMessageBox(
              "알림",
              response.data.reply.korMsg,
              "확인",
              null
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showWithdraw() {
      this.withdrawStatus.show = !this.withdrawStatus.show;
    },
    userLogoff() {
      let loginType = sessionStorage.getItem("loginType");
      let queryParam = {};
      queryParam = {
        loginType: loginType,
      };
      http.request(this.contextPageId, "DTS_CMP_00044", {
          query: queryParam,
        })
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    gotoLoginPage() {
      this.$store.state.isLoggedIn = false;
      this.$router.go();
    },
  },
};
</script>
<style scoped>
.box_border {
  padding: 32px;
  border: 1px solid #dbdbdb;
}
.box_border + .box_border {
  margin-top: 24px;
}
.box_border h2 {
  font-size: 20px;
  line-height: 29px;
  color: #222;
}
table {
  width: 100%;
  border: 0;
}
tr {
  padding-top: 12px;
  text-align: left;
  vertical-align: middle;
  height: 72px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
}
.info_wrap {
  position: relative;
  margin-left: 4px;
  width: 16px;
  height: 16px;
  display: inline-block;
}
.btn_info {
  display: block;
  font-size: 0;
  line-height: 0;
  border: 0;
  width: 16px;
  height: 16px;
  background: url(../../../../../assets/images/aicc/ic_info.png) no-repeat
    center;
}
th {
  padding-top: 12px;
  text-align: left;
  vertical-align: middle;
  height: 72px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
}
td {
  padding-top: 12px;
  text-align: left;
  vertical-align: middle;
  height: 72px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
}

.delete_link{
  color: #516af4;
  cursor: pointer;
}
</style>